 export class Consorcio{

    public id:number;
    public codigoConsorcio:string;
    public nombreConsorcio:string;
    public nombreLargo:string;
    public direccion:string;
    public telefono:string;
    public email:string;
    public contacto:string;
    public codigoMoneda:string;
    public vigenciaContrato: any;
    public estado:string;      
    public documentoPrefijo:string;  
    public codigoBodega:string; 
    public idReferenciaERP:string;      

 }


// WEBPACK FOOTER //
// D:/TPL ILG/3PL_ILG/src/app/model/consorcio.ts